









import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Atick extends Vue {
  get developers () {
    return [
      {
        name: 'Іван',
        last_name: 'Другак',
        photo: ''
      }
    ];
  }
}
